import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StarField from '../Mars/components/StarField';
import SecretAdminPanel from '../Admin/SecretAdminPanel';
import { usePortfolioData } from '../../hooks/usePortfolioData';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();
  const [showAdmin, setShowAdmin] = useState(false);
  const { data } = usePortfolioData();

  const handleLaunchClick = () => {
    navigate('/launch', { replace: true });
  };

  return (
    <div className="landing-container">
      <StarField speedFactor={0.2} />

      <div className="landing-content">
        <header className="landing-header fade-in-up">
          <h2 className="sub-title">WELCOME TO</h2>
          <h1 className="main-title">THE MARSMAN PORTFOLIO</h1>
        </header>

        <div className="launch-control-pannel fade-in-up delay">
          <div className="launch-btn-wrapper" onClick={handleLaunchClick}>
            <div className="launch-ring"></div>
            <button className="launch-btn">LAUNCH</button>
          </div>
          <p className="launch-caption">Click to Enter Orbit</p>
        </div>
      </div>

      <div className="skip-container">
        <button className="skip-btn" onClick={() => navigate('/mars')}>
          <span className="arrow">➜</span> SKIP TO MISSION CONTROL
        </button>
      </div>

      {/* Secret Admin Trigger - Controlled by Firebase */}
      {data?.adminControl && (
        <div
          style={{
            position: 'absolute',
            bottom: '10px',
            right: '10px',
            opacity: 0.3,
            cursor: 'pointer',
            fontSize: '20px',
            zIndex: 9999
          }}
          onClick={() => setShowAdmin(true)}
        >
          ⚙️
        </div>
      )}

      {showAdmin && <SecretAdminPanel onClose={() => setShowAdmin(false)} />}
    </div>
  );
};

export default LandingPage;
